export const email = {
    NOVOATUALIZA: 'NOVOATUALIZA',    
    PESQUISA: 'PESQUISA',
    PESQUISATIPOS: 'PESQUISATIPOS',
    PESQUISACHAVES: 'PESQUISACHAVES',
    RENDERIZAR: 'RENDERIZAR',
    PESQUISATIPOSEMAIL: 'PESQUISATIPOSEMAIL',
    ENVIAEMAILNOTIFICACAO: 'ENVIAEMAILNOTIFICACAO'
}